import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Modal, Tabs, Text } from '@Sage/hoi-poi-ui';
import { SectionList } from '@Sage/ssm-web5';
import AbsoluteLoader from 'components/AbsoluteLoader';
import { getLiteral } from 'utils/getLiteral';
import { ConfigActions } from 'actions';

import MailchimpUtils from '../../utils/MailchimpUtils';
import Literal from '../../../../../components/Literal';
import IntegrationConfigurationInput from '../fields/IntegrationConfigurationInput';
import IntegrationCountrySelect from '../fields/IntegrationCountrySelect';
import IntegrationMultiUserSearch from '../fields/IntegrationMultiUserSearch';
import IntegrationSelectedUserItem from '../fields/IntegrationSelectedUserItem';
import SyncStatus from '../CustomIntegrationsComponents/syncStatus';
import ExportDialog from '../CustomIntegrationsComponents/exportDialog/exportDialog';
import DisableIntegration from '../CustomIntegrationsComponents/disableIntegration';
import {
    getBlackListColumnDefs,
    getBlackListSectionListLayout,
    mapBlackListRows,
} from './mailchimpBlacklistTableConfig';
import { ProviderInactive } from '..';
import { InfoAlert, ErrorAlert } from '../../../../../components/alerts';
import Context from '../../../../../managers/Context';
import './style.scss';

const MAILCHIMP_TABS = {
    status: 'status',
    blacklist: 'blacklist',
};

function mapDispatchToProps(dispatch) {
    let { updateSpecificPermissions } = bindActionCreators(ConfigActions, dispatch);
    return {
        updateSpecificPermissions: updateSpecificPermissions,
    };
}

@connect(null, mapDispatchToProps)
class MailchimpComponent extends Component {
    state = {};

    componentDidMount() {
        let { provider, languageISO } = this.props;

        languageISO = !languageISO ? 'en' : languageISO;

        if (provider && provider.data) {
            this.setState({
                configuration: provider.data.Configuration,
                providerId: provider.data.ProviderId,
                mailchimpOauthProcess: false,
                loadingMailchimpTabs: true,
                errorMailchimpTabs: false,
                goToAuthorize: false,
                validAuth: false,
                isActive: provider.data.IsActive,
                loading: true,
                showDisableDialog: false,
                showLoadingDisableDialog: false,
                configurationFields: { language: languageISO },
                errorText: {},
                forceGoToAuthorize: false,
                toggled: true,
                showExportDialog: false,
                activeTab: MAILCHIMP_TABS.status,
            });

            if (provider.data.IsActive) {
                this.getMailchimpData();
            } else {
                this.setState({ loading: false });
            }
        }
    }

    getMailchimpData = (forceGoToAuthorize) => {
        let { provider, updateSpecificPermissions } = this.props;
        this.setState({ loading: true });
        Context.settingsManager.validateOauth(
            provider.data.ProviderId,
            () => {
                if (!provider.data.IsActive) {
                    Context.settingsManager.setActivation(
                        provider.data.ProviderId,
                        () => {
                            let refreshWidgetsTemplatesPromise = new Promise((resolve) => {
                                Context.settingsManager.refreshWebTemplates(
                                    () => {
                                        resolve();
                                    },
                                    (error) => {
                                        resolve();
                                    },
                                );
                            });

                            refreshWidgetsTemplatesPromise.then(() => {
                                this.setState({
                                    isActive: true,
                                    validAuth: true,
                                    loading: false,
                                    mailchimpOauthProcess: false,
                                    forceGoToAuthorize: false,
                                });
                                this.getTab1Data(
                                    provider.data.ProviderId,
                                    provider.data.Name.toLowerCase(),
                                );

                                // update redux
                                updateSpecificPermissions &&
                                    updateSpecificPermissions([{ key: 'mailChimp', value: true }]);
                            });
                        },
                        (error) => {
                            console.log('error isactive');
                        },
                    );
                } else {
                    this.setState({
                        isActive: true,
                        validAuth: true,
                        loading: false,
                        mailchimpOauthProcess: false,
                        forceGoToAuthorize: false,
                    });
                    this.getTab1Data(provider.data.ProviderId, provider.data.Name.toLowerCase());
                }
            },
            () => {
                if (forceGoToAuthorize === true) {
                    this.setState({
                        loading: false,
                        mailchimpOauthProcess: false,
                        goToAuthorize: true,
                        forceGoToAuthorize: true,
                    });
                } else {
                    this.setState({ loading: false, goToAuthorize: true });
                }
            },
            (error) => {
                this.setState({ loading: false, goToAuthorize: true });
            },
        );
    };

    getTab1Data = (providerId, providerName) => {
        let cronStatus = new Promise((resolve, reject) => {
            Context.settingsManager.getCronStatus(
                providerId,
                (cronstatus) => {
                    resolve(cronstatus);
                },
                (cronstatus) => {
                    resolve(cronstatus);
                },
                (error) => {
                    reject();
                },
            );
        });

        let users = new Promise((resolve, reject) => {
            let offset = 0;
            let maxResults = 5000;
            Context.settingsManager.getUsersProviderRoles(
                providerName,
                offset,
                maxResults,
                (data) => {
                    resolve(data);
                },
                () => {
                    reject();
                },
                (error) => {
                    reject();
                },
            );
        });

        let blackList = new Promise((resolve, reject) => {
            let offset = 0;
            let maxResults = 100;
            Context.settingsManager.getBlackListedEmails(
                offset,
                maxResults,
                (data) => {
                    resolve(data);
                },
                () => {
                    reject();
                },
                (error) => {
                    reject();
                },
            );
        });

        Promise.all([cronStatus, users, blackList])
            .then((data) => {
                this.setState({
                    cronstatus: data[0],
                    userList: data[1],
                    blackListData: data[2],
                    loadingMailchimpTabs: false,
                });
            })
            .catch(() => {
                this.setState({ loadingMailchimpTabs: false, errorMailchimpTabs: true });
            });
    };

    validateEmail = (email) => {
        let re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let result = re.test(email.toLowerCase());
        return result;
    };

    checkFieldRequired = (key, configurationFields, errorText) => {
        if (!configurationFields[key] || configurationFields[key].trim().length === 0) {
            errorText[key] = 'helptext_required_field';
            return false;
        } else {
            errorText[key] = '';
            return true;
        }
    };

    checkFormValues = (configurationFields) => {
        let { errorText } = this.state;
        let configFieldsOk = true;

        configFieldsOk = this.checkFieldRequired('company', configurationFields, errorText);
        configFieldsOk = this.checkFieldRequired('address1', configurationFields, errorText);
        configFieldsOk = this.checkFieldRequired('city', configurationFields, errorText);
        configFieldsOk = this.checkFieldRequired('state', configurationFields, errorText);
        configFieldsOk = this.checkFieldRequired('zip', configurationFields, errorText);

        if (!configurationFields.email || configurationFields.email.trim().length === 0) {
            errorText.email = 'helptext_required_field';
            configFieldsOk = false;
        } else if (!this.validateEmail(configurationFields.email.trim())) {
            errorText.email = 'error_invalid_email_format';
            configFieldsOk = false;
        } else {
            errorText.email = '';
        }

        if (!configurationFields.company || configurationFields.company.trim().length === 0) {
            errorText.company = 'helptext_required_field';
            configFieldsOk = false;
        } else {
            errorText.company = '';
        }

        if (!configurationFields.state || configurationFields.state.trim().length === 0) {
            errorText.state = 'helptext_required_field';
            configFieldsOk = false;
        } else {
            errorText.state = '';
        }

        if (!configurationFields.address1 || configurationFields.address1.trim().length === 0) {
            errorText.address1 = 'helptext_required_field';
            configFieldsOk = false;
        } else {
            errorText.address1 = '';
        }

        if (!configurationFields.phone) {
            configurationFields.phone = '';
        }

        if (!configurationFields.language || configurationFields.language.trim().length === 0) {
            errorText.language = 'helptext_required_field';
            configFieldsOk = false;
        } else if (configurationFields.language.trim().length < 2) {
            errorText.language = 'error_two_characters_mailchimp';
        } else {
            errorText.language = '';
        }

        if (!configurationFields.address2) {
            configurationFields.address2 = '';
        }

        if (!configurationFields.country || configurationFields.country.trim().length === 0) {
            errorText.country = 'helptext_required_field';
            configFieldsOk = false;
        } else if (configurationFields.country.trim().length < 1) {
            errorText.country = 'error_two_characters_mailchimp';
        } else {
            errorText.country = '';
        }

        this.setState({ errorText: errorText, configurationFields: configurationFields });

        return configFieldsOk;
    };

    onClickAuthorize = () => {
        let { iduser, implementation } = this.props;
        let { configurationFields } = this.state;
        if (this.checkFormValues(configurationFields)) {
            let child = window.open(
                MailchimpUtils.getMailchimpUrl(iduser, implementation, configurationFields),
                '_blank',
                'width:550,height:700,modal=yes,alwaysRaised=yes',
            );
            this.setState({ mailchimpOauthProcess: true, goToAuthorize: false });

            let timer = setInterval(() => {
                if (child.closed) {
                    this.getMailchimpData(true);
                    clearInterval(timer);
                }
            }, 500);
        }
    };

    onClickContinue = () => {
        let { implementation } = this.props;
        this.setState({ goToAuthorize: true });
        const data = {
            subject: `Mailchimp Activation ${implementation}`,
            email: 'success@forcemanager.net',
            body: `La implementación ${implementation} ha intentado activar la integración con Mailchimp`,
        };
        Context.domainManager.sendMailSimple(
            data,
            () => {},
            () => {},
        );
    };

    onClickDisable = (isInputChecked) => {
        if (!isInputChecked) {
            this.setState({ showDisableDialog: true, toggled: true });
        }
    };

    handleDisableClose = () => {
        const { showLoadingDisableDialog } = this.state;
        if (!showLoadingDisableDialog) {
            this.setState({ showDisableDialog: false, toggled: true });
        }
    };

    disableUserRoles = () => {
        let { userList } = this.state;
        let { provider } = this.props;
        let processUsersDisable = userList.map((user) => {
            user.userHaveRole = 0;
            return user;
        });
        Context.settingsManager.setUsersProviderRoles(
            provider.data.Name.toLowerCase(),
            processUsersDisable,
            () => {
                this.setState({
                    showDisableDialog: false,
                    validAuth: false,
                    isActive: false,
                    loadingDialog: false,
                });
            },
            (error) => {
                this.setState({ error: true, loadingDialog: false, showDisableDialog: false });
            },
        );
    };

    handleDisable = () => {
        this.setState({ showLoadingDisableDialog: true, loadingDialog: true });
        let { providerId } = this.state;
        const { updateSpecificPermissions } = this.props;
        Context.settingsManager.disableIntegration(
            providerId,
            () => {
                this.disableUserRoles();

                if (window.refreshPermissions) {
                    window.refreshPermissions();
                }

                // update redux
                updateSpecificPermissions &&
                    updateSpecificPermissions([{ key: 'mailChimp', value: false }]);
            },
            (error) => {
                console.log('error isactive');
            },
        );
    };

    showExportDialog = () => {
        this.setState({ showExportDialog: true });
    };

    closeExportDialog = () => {
        this.setState({ showExportDialog: false });
    };

    onChangeTab = (activeTab) => {
        this.setState({ activeTab });
    };

    renderMailchimpTabsContent = (provider) => {
        let { activeTab, loadingMailchimpTabs, errorMailchimpTabs, toggled } = this.state;
        let renderContent = loadingMailchimpTabs ? (
            this.renderLoading()
        ) : errorMailchimpTabs ? (
            this.renderError()
        ) : (
            <div id="active-integration-container">
                <DisableIntegration
                    onDisable={this.onClickDisable}
                    provider={provider}
                    toggled={toggled}
                />
                <Tabs
                    activeKey={activeTab}
                    className="integrations-tabs"
                    onChange={this.onChangeTab}
                    tabs={[
                        {
                            key: MAILCHIMP_TABS.status,
                            title: getLiteral('label_status_zendesk'),
                            content: this.renderStatusTab(),
                        },
                        {
                            key: MAILCHIMP_TABS.blacklist,
                            title: getLiteral('label_mailchimp_blacklist'),
                            content:
                                activeTab === MAILCHIMP_TABS.blacklist
                                    ? this.renderBlackListTab()
                                    : null,
                        },
                    ]}
                />
            </div>
        );
        return renderContent;
    };

    processDataMultiFuzzySearch = (data, selected) => {
        let filteredData;
        if (selected) {
            filteredData = data.filter((value) => {
                return value.userHaveRole === 1;
            });
        } else {
            filteredData = data;
        }
        let dataProcessed = filteredData.map((value) => {
            let text = value.userFirstName + ' ' + value.userLastName;
            let id = value.userId;
            let info2 = value.environmentName;
            let info3 = value.email === '' ? 'NO EMAIL' : value.email;
            return {
                text,
                id,
                value: (
                    <IntegrationSelectedUserItem id={id} info2={info2} info3={info3} text={text} />
                ),
            };
        });
        return dataProcessed;
    };

    onSaveUsersSelected = (usersSelected) => {
        this.setState({ loading: true });
        let { userList } = this.state;
        let { provider } = this.props;
        let processUsersSelected = userList.map((user) => {
            for (let i = 0; i < usersSelected.length; i++) {
                if (user.userId === usersSelected[i].id) {
                    user.userHaveRole = 1;
                    return user;
                }
            }
            user.userHaveRole = 0;
            return user;
        });
        Context.settingsManager.setUsersProviderRoles(
            provider.data.Name.toLowerCase(),
            processUsersSelected,
            () => {
                this.setState({ userSaved: true, loading: false });
            },
            (error) => {
                this.setState({ error: true, loading: false });
            },
        );
    };

    renderStatusTab = () => {
        let { cronstatus, userList, userSaved } = this.state;
        let data = this.processDataMultiFuzzySearch(userList, false);
        let itemsSelected = this.processDataMultiFuzzySearch(userList, true);
        return (
            <div className="status-tab-container">
                <SyncStatus
                    cronstatus={cronstatus}
                    onDisable={this.onClickDisable}
                    enabledSyncLiteral="label_enabled_sync_description_zendesk"
                    errorSyncLiteral="label_failed_sync_description_integration"
                    intialSyncLiteral="label_sync_description_mailchimp"
                />
                <div className="mailchimp-multifuzzy-container">
                    <Text as="div" className="mailchimp-multifuzzy-header" medium type="subtitle1">
                        {getLiteral('label_mailchimp_manage_user_permissions')}
                    </Text>
                    <Text as="div" className="mailchimp-multifuzzy-desc" type="body">
                        {getLiteral('label_mailchimp_description_user_permissions')}
                    </Text>
                    <IntegrationMultiUserSearch
                        data={data}
                        noItemsSelectedLiteral={'placeholder_mailchimp_add_users'}
                        numItemsSelectedLiteral={'label_selected_users'}
                        itemsSelectedProps={itemsSelected}
                        onSave={this.onSaveUsersSelected}
                    />
                </div>
            </div>
        );
    };

    renderBlackListTab = () => {
        let { blackListData } = this.state;
        let renderContent = (
            <div className="mailchimp-inside-tab-content">
                <Text as="div" className="mailchimp-blacklist-title" medium type="subtitle1">
                    {getLiteral('label_mailchimp_blacklist')}
                </Text>
                <Text as="div" className="mailchimp-blacklist-desc" type="body">
                    {getLiteral('label_mailchimp_blacklist_desc')}
                </Text>
                {blackListData.Result && blackListData.Result.length > 0 ? (
                    this.renderBlackListTable(blackListData.Result)
                ) : (
                    <div className="blacklist-no-results">
                        <div className="blacklist-no-results-center">
                            <Text type="body">{getLiteral('label_mailchimp_blacklist_empty')}</Text>
                        </div>
                    </div>
                )}
            </div>
        );
        return renderContent;
    };

    renderBlackListTable = (blackListData) => {
        const rows = mapBlackListRows(blackListData);
        const { domLayout, classNameModifier } = getBlackListSectionListLayout(rows.length);

        return (
            <div className="blacklist-tab-container">
                <div className="blacklist-tab-container__toolbar">
                    <Button onClick={this.showExportDialog} type="secondary">
                        {getLiteral('label_export_blacklist')}
                    </Button>
                </div>
                <SectionList
                    className={`mailchimp-blacklist-section-list ${classNameModifier}`}
                    columnDefs={getBlackListColumnDefs()}
                    domLayout={domLayout}
                    getRowNodeId={(item) => item.id}
                    id="mailchimp-blacklist"
                    rowBuffer={20}
                    rows={rows}
                    totalRowData={rows.length}
                />
            </div>
        );
    };
    renderError = () => {
        return (
            <div className="integrations">
                <div className="description-integrations">
                    <Text type="body">{getLiteral('error_unexpected')}</Text>
                </div>
            </div>
        );
    };

    renderLoading = () => {
        return (
            <div>
                <AbsoluteLoader size="huge" />
            </div>
        );
    };

    renderMailchimpInitialWindow = (provider) => {
        return (
            <div>
                <ProviderInactive provider={provider} />
                <div className="mailchimp-continue-btn">
                    <Button onClick={this.onClickContinue} type="primary">
                        {getLiteral('action_continue')}
                    </Button>
                </div>
            </div>
        );
    };

    onChangeInput = (key, value) => {
        let { configurationFields } = this.state;
        configurationFields[key] = value;
        this.setState({ configurationFields: configurationFields });
    };

    onChangeCountry = (value) => {
        this.onChangeInput('country', value);
    };

    renderMailchimpOauth = () => {
        let { configurationFields, errorText, forceGoToAuthorize, isActive, validAuth } =
            this.state;
        let AuthWrong = forceGoToAuthorize ? (
            <InfoAlert
                text={<Literal literal="label_oauth_interrumped_salesforce" />}
                iconDisplay={false}
            />
        ) : isActive && !validAuth ? (
            <ErrorAlert
                text={<Literal literal="label_oauth_failed_salesforce" />}
                iconDisplay={false}
            />
        ) : (
            <div />
        );

        let renderContent = (
            <div className="mailchimp-detail-provider">
                <div className="mailchimp-title">
                    <Literal
                        className="mailchimp-title-label"
                        literal="title_integration_mailchimp"
                    />
                </div>
                <div className="provider-detail">
                    <div className="content">
                        <div className="description">
                            <Literal literal="label_authorize_description_mailchimp" />
                        </div>
                    </div>
                </div>
                <div className="auth-wrong">{AuthWrong}</div>
                <div className="mailchimp-oauth-form">
                    <div className="mailchimp-oauth-form__column">
                        <IntegrationConfigurationInput
                            literal="label_company_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'company')}
                            value={configurationFields ? configurationFields.company : ''}
                            objName="company"
                            maxLength="60"
                            errorText={errorText}
                        />
                        <IntegrationConfigurationInput
                            literal="label_email_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'email')}
                            value={configurationFields ? configurationFields.email : ''}
                            objName="email"
                            maxLength="254"
                            errorText={errorText}
                        />
                        <IntegrationConfigurationInput
                            literal="label_phone_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'phone')}
                            value={configurationFields ? configurationFields.phone : ''}
                            objName="phone"
                            maxLength="20"
                            optional="true"
                            errorText={errorText}
                        />
                        <IntegrationConfigurationInput
                            literal="label_address1_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'address1')}
                            value={configurationFields ? configurationFields.address1 : ''}
                            objName="address1"
                            maxLength="180"
                            multiline="true"
                            rows={2}
                            errorText={errorText}
                        />
                        <IntegrationConfigurationInput
                            literal="label_address2_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'address2')}
                            value={configurationFields ? configurationFields.address2 : ''}
                            objName="address2"
                            maxLength="180"
                            multiline="true"
                            rows={2}
                            optional="true"
                            errorText={errorText}
                        />
                    </div>
                    <div className="mailchimp-oauth-form__column">
                        <IntegrationConfigurationInput
                            literal="label_city_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'city')}
                            value={configurationFields ? configurationFields.city : ''}
                            objName="city"
                            maxLength="60"
                            errorText={errorText}
                        />
                        <IntegrationConfigurationInput
                            literal="label_state_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'state')}
                            value={configurationFields ? configurationFields.state : ''}
                            objName="state"
                            maxLength="60"
                            errorText={errorText}
                        />
                        <IntegrationCountrySelect
                            error={errorText.country ? getLiteral(errorText.country) : undefined}
                            literal="label_country_mailchimp"
                            mandatory
                            onChange={this.onChangeCountry}
                            value={configurationFields?.country}
                        />
                        <IntegrationConfigurationInput
                            literal="label_zip_mailchimp"
                            onChange={this.onChangeInput.bind(this, 'zip')}
                            value={configurationFields ? configurationFields.zip : ''}
                            objName="zip"
                            maxLength="20"
                            errorText={errorText}
                        />
                    </div>
                </div>
                <div className="mailchimp-authorize-btn">
                    <Button onClick={this.onClickAuthorize} type="primary">
                        {getLiteral('action_authorize_zendesk')}
                    </Button>
                </div>
            </div>
        );

        return renderContent;
    };

    renderOauthInProcess = () => {
        return (
            <div className="mailchimp-waiting-content">
                <Text as="div" className="mailchimp-waiting-text" type="body">
                    {getLiteral('label_waiting_oauth_mailchimp')}
                </Text>
                <Button onClick={this.getMailchimpData} type="primary">
                    {getLiteral('action_waiting_oauth_zendesk')}
                </Button>
            </div>
        );
    };

    render() {
        let { provider } = this.props;
        let {
            error,
            loading,
            mailchimpOauthProcess,
            goToAuthorize,
            isActive,
            validAuth,
            showDisableDialog,
            loadingDialog,
            showExportDialog,
        } = this.state;
        let renderContent = loading
            ? this.renderLoading()
            : error
              ? this.renderError()
              : goToAuthorize
                ? this.renderMailchimpOauth()
                : mailchimpOauthProcess
                  ? this.renderOauthInProcess()
                  : !isActive && !validAuth
                    ? this.renderMailchimpInitialWindow(provider)
                    : this.renderMailchimpTabsContent(provider);
        return (
            <div className="integrations-management mailchimp-management-integration">
                {renderContent}
                <Modal
                    isOpen={showDisableDialog}
                    onCancel={this.handleDisableClose}
                    onConfirm={this.handleDisable}
                    title={getLiteral('action_disable_zendesk')}
                    confirmText={getLiteral('action_accept')}
                    cancelText={getLiteral('action_cancel')}
                    size="small"
                    isConfirmLoading={loadingDialog}
                >
                    <Text>{getLiteral('label_disable_mailchimp')}</Text>
                </Modal>
                <ExportDialog
                    entity="blacklist"
                    closeExportDialog={this.closeExportDialog}
                    isDownload={true}
                    showDialog={showExportDialog}
                    literalDesc="label_export_blacklist_desc"
                />
            </div>
        );
    }
}

export default MailchimpComponent;
